angular.module('dealerware.web.data').factory('DealerwareScanModel', function ($http,Model,$q) {

    var model = new Model({
        baseEndpoint: '/locations/:location_id/cars/:vehicle_id/car_scans'
    });

    return model;
});
